import React from 'react'
import Icon from 'react-icon-base'

const Project = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Project" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Project" transform="translate(-129.000000, -1674.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Group-7" transform="translate(0.000000, 1157.000000)">
            <rect
              id="Rectangle-Copy"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="274"
              rx="4"
            />
            <g id="Group-Copy" transform="translate(98.000000, 108.000000)" stroke="#3498DB">
              <path
                d="M13,32 C10.5555556,32 6.88888889,32 2,32 C0.8954305,32 0,31.1045695 0,30 L0,2 C0,0.8954305 0.8954305,0 2,0 L24,0 C25.1045695,0 26,0.8954305 26,2 C26,6.88888889 26,10.5555556 26,13"
                id="Path"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <g id="Group" transform="translate(11.000000, 13.000000)" strokeWidth="2">
                <path
                  d="M12,12 C12,14.6666667 12,17.6666667 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C6.33333333,12 9.33333333,12 12,12 Z"
                  id="Oval"
                  transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
                />
                <path d="M9,0 C4.02943725,0 0,4.02943725 0,9 C2,9 5,9 9,9 C9,4.33333333 9,1.33333333 9,0 Z" id="Oval" />
              </g>
              <line x1="3.5" y1="4.5" x2="9.5" y2="4.5" id="Line-2-Copy-4" strokeWidth="1.5" strokeLinecap="round" />
              <line x1="3.5" y1="8.5" x2="9.5" y2="8.5" id="Line-2-Copy-5" strokeWidth="1.5" strokeLinecap="round" />
              <line x1="3.5" y1="12.5" x2="14.5" y2="12.5" id="Line-2-Copy" strokeWidth="1.5" strokeLinecap="round" />
              <line x1="3.5" y1="16.5" x2="12.5" y2="16.5" id="Line-2-Copy-3" strokeWidth="1.5" strokeLinecap="round" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Project.defaultProps = {
  size: 30
}

export default Project
